import React, { useState, useEffect } from 'react';
/**
 * `CustomerAcceptance` renders terms/acceptance text and a single checkbox to
 * capture agreement.
 *
 * Behaviour:
 * - Renders each string in `customerAcceptanceText` as a paragraph.
 * - Maintains a local `agreed` flag and propagates changes via
 *   `setAgreedCustomerAcceptance`.
 * - Resets `agreed` to false when `agreedTermsAndConditions` becomes false.
 */

import Checkbox from './Checkbox/Checkbox';

export type CustomerAcceptanceProps = {
  customerAcceptanceText: string[];
  setAgreedCustomerAcceptance: (agreedCustomerAcceptance: boolean) => void;
  customerAcceptanceTickboxText: string;
  agreedTermsAndConditions: boolean;
};

export const CustomerAcceptance = ({
  customerAcceptanceText,
  setAgreedCustomerAcceptance,
  customerAcceptanceTickboxText,
  agreedTermsAndConditions
}: CustomerAcceptanceProps): JSX.Element => {
  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    setAgreedCustomerAcceptance(agreed);
  }, [agreed]);

  useEffect(() => {
    if (!agreedTermsAndConditions) {
      setAgreed(false);
    }
  }, [agreedTermsAndConditions]);

  const renderParagraph = (section: string, id: number) => {
    return (
      <p
        id={`acceptance-text-${id}`}
        key={`acceptance-text-${id}`}
        className='m1-bottom'>
        {section}
      </p>
    );
  };

  const onChange = () => {
    setAgreed(!agreed);
  };

  return (
    <div>
      <>{customerAcceptanceText.map((text, i) => renderParagraph(text, i))}</>
      <Checkbox
        id='acceptance-text-checkbox'
        checked={agreed}
        text={customerAcceptanceTickboxText}
        onChange={onChange}
      />
    </div>
  );
};

export default CustomerAcceptance;
